import { useQuery, useQueryClient } from '@tanstack/react-query';

import { Click2PayProfileMutationResult } from '@/react-query/hooks/mutation/use-click2pay';
import { useClick2PayIsAllowed } from '@/react-query/hooks/useClick2PayIsAllowed';
import { getClick2PayEligibleCards, getClick2PayProfile } from '@/react-query/services/click2pay';

import { Click2PayCustomerProfile, EligibleCardInfo } from '@generated-types';

export const click2PayProfileQueryString = 'click2PayProfileCreateQuery';

export const useClick2PayProfile = () => {
    const click2PayIsAllowed = useClick2PayIsAllowed();

    return useQuery<Click2PayCustomerProfile>({
        queryKey: ['click2PayProfile'],
        queryFn: () => getClick2PayProfile(),
        enabled: click2PayIsAllowed,
    });
};

export const useClick2PayEligibleCards = () => {
    const click2PayIsAllowed = useClick2PayIsAllowed();

    return useQuery<EligibleCardInfo[]>({
        queryKey: ['c2pEligibleCards'],
        queryFn: getClick2PayEligibleCards,
        enabled: click2PayIsAllowed,
    });
};

/*
 Custom query to cache the data coming from useClick2PayCreateProfileMutation,
 this is acting as a normal query based on the updates we set in the mutation
*/
export const useClick2PayProfileMutationResult = () => {
    const click2PayIsAllowed = useClick2PayIsAllowed();
    const queryClient = useQueryClient();

    return useQuery<Click2PayProfileMutationResult>({
        queryKey: [click2PayProfileQueryString],
        queryFn: () =>
            queryClient.getQueryData<Click2PayProfileMutationResult>([
                click2PayProfileQueryString,
            ]) as Click2PayProfileMutationResult,
        enabled: click2PayIsAllowed,
        initialData: {
            isError: false,
            isPending: false,
        } as Click2PayProfileMutationResult,
    }).data;
};
